import * as React from "react"
import { Label } from "@/components/ui/label"
import {
 Select,
 SelectContent,
 SelectItem,
 SelectTrigger,
 SelectValue,
} from "@/components/ui/select"
import { FormMessage } from "@/components/ui/form"
import { cn } from "@/lib/utils"

export interface SelectOption {
 value: string
 label: string
 disabled?: boolean
}

export interface LeadSelectFieldProps {
 label?: string
 value: string
 options: SelectOption[]
 onChange: (value: string) => void
 error?: string
 hint?: string
 required?: boolean
 placeholder?: string
 disabled?: boolean
 containerClassName?: string
 className?: string
}

export const LeadSelectField: React.FC<LeadSelectFieldProps> = ({
 label,
 value,
 options,
 onChange,
 error,
 hint,
 required,
 placeholder = "Selecione...",
 disabled,
 containerClassName,
 className,
}) => {
 const fieldId = React.useId()

 // Filtrar opções com value vazio (Radix UI não permite)
 // e tratar o valor vazio como undefined para mostrar o placeholder
 const validOptions = options.filter(opt => opt.value !== '')
 const selectValue = value === '' ? undefined : value

 const handleValueChange = (newValue: string) => {
 // Se o valor selecionado for undefined (placeholder), passar string vazia
 onChange(newValue || '')
 }

 return (
 <div className={cn("space-y-2", containerClassName)}>
 {label && (
 <Label 
 htmlFor={fieldId} 
 className={required ? "after:content-['*'] after:ml-0.5 after:text-destructive" : ""}
 >
 {label}
 </Label>
 )}
 <Select value={selectValue} onValueChange={handleValueChange} disabled={disabled}>
 <SelectTrigger 
 id={fieldId}
 className={cn(
 error && "border-destructive focus:ring-destructive",
 className
 )}
 aria-invalid={!!error}
 aria-describedby={error ? `${fieldId}-error` : hint ? `${fieldId}-hint` : undefined}
 >
 <SelectValue placeholder={placeholder} />
 </SelectTrigger>
 <SelectContent>
 {validOptions.map((option) => (
 <SelectItem 
 key={option.value} 
 value={option.value}
 disabled={option.disabled}
 >
 {option.label}
 </SelectItem>
 ))}
 </SelectContent>
 </Select>
 {hint && !error && (
 <p id={`${fieldId}-hint`} className="text-[0.8rem] text-muted-foreground">
 {hint}
 </p>
 )}
 {error && (
 <FormMessage id={`${fieldId}-error`} className="text-[0.8rem] font-medium text-destructive">
 {error}
 </FormMessage>
 )}
 </div>
 )
}

